import DashBoardEmployeeComponent from "./DashBoardEmployeeComponent.vue";
import DashBoardResponsibleComponent from "./DashBoardResponsibleComponent.vue";

export { DashBoardEmployeeComponent, DashBoardResponsibleComponent };
